import { Container } from "typedi";
import { AccountService } from "../../services";
import tronWeb from "tronweb";

export class AccountInfoService {
  public fetchAccountTransactions = async (params) => {
    try {
      let accountService = Container.get(AccountService);
      const { address } = params;
      if (!tronWeb.isAddress(address)) throw new Error("Address not valid!");

      const { rise, cash, trx, created } = await accountService.getAccount(
        address
      );

      return {
        rise,
        cash,
        trx,
        created,
      };
    } catch (e) {
      console.log(e);
      if (e.message) {
        throw e;
      }
      throw new Error("Error connecting to account service");
    }
  };
}
